import { render, staticRenderFns } from "./SearchUserAndInvite.vue?vue&type=template&id=2610f8ca&scoped=true&lang=pug"
import script from "./SearchUserAndInvite.vue?vue&type=script&lang=js"
export * from "./SearchUserAndInvite.vue?vue&type=script&lang=js"
import style0 from "./SearchUserAndInvite.vue?vue&type=style&index=0&id=2610f8ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2610f8ca",
  null
  
)

export default component.exports